import React, { useEffect, useState } from 'react'
import api from "../../services/api"
import { useNavigate } from 'react-router'
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import Paginator from "../../shared/Paginator";
import config from "../../config";
import { formatDate, formatDateWithTime, formatDateYYYYMMDD, ISODateString } from "../../utils/dateFormat";
import { roles } from '../../utils/constants';

function LangwiseReport(object) {
    const campaign_id = object.campaign_id
    const camp = object.camp
    const x_value = camp.x_value
    const navigate = useNavigate()
    const [data,setData] = useState([])
    const [loader, setLoader] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        getdata(campaign_id,event.selected)
      };
    
    const getdata =async (campid=campaign_id,page=0)=>{
        setLoader(true);
        try {
            let res = await api({
                url: '/reports/daywisereports',
                method: 'POST',
                responseType: 'json',
                data: {
                 campid,
                 x_value,
                 page,
                 action:"langwise",
                 limit: config.PER_PAGE,
                }
              });
              if (res.code === 200) {
                setData(res.data);
                setTotalPages(Math.ceil(parseInt(res.data.total) / config.PER_PAGE));
              }
              setLoader(false);

        } catch (error) {
            console.error(error);
      if (error.response.status === 401)
        navigate("/")
        }
        
    }
    useEffect(()=>{
        getdata()
    },[])
  return (
    <div>
      <div className="overflow-x-auto mb-4">
        <table className='table table-bordered'>
          <thead>
            <tr>
              {/* Campaign Creation */}
              {/* <th scope="col">Campaign Id</th> */}
              <th scope="col">Language</th>
              <th scope="col">Impressions</th>
              <th scope="col">Clicks</th>
              {localStorage.getItem("role") !== roles.advertiser && <th scope="col">Advertiser Impressions</th>}
              {localStorage.getItem("role") !== roles.advertiser && <th scope="col">Advertiser Clicks</th>}
              {localStorage.getItem("role") !== roles.advertiser && <th scope="col">CTR(%)</th>}
              {localStorage.getItem("role") !== roles.advertiser && <th scope="col">ECPM</th>}
              <th scope="col">Spent</th>
              {localStorage.getItem("role") !== roles.advertiser && <th scope='col'>Advertiser Spent</th>}
            </tr>
          </thead>
          {data?.length && !loader ? (
            <tbody>
              {data?.map((item, index) => {
                return (
                  <tr key={item._id} >
                    <td >{item._id}</td>
                    <td>{localStorage.getItem("role") !== roles.advertiser ? item.total_imp : parseInt(item.adv_total_imp)}</td>
                    <td>{localStorage.getItem("role") !== roles.advertiser ? item.total_click : parseInt(item.adv_total_click)}</td>
                    {localStorage.getItem("role") !== roles.advertiser && <td >{ parseInt(item.adv_total_imp)}</td>}
                    {localStorage.getItem("role") !== roles.advertiser && <td >{ parseInt(item.adv_total_click)}</td>}
                    {localStorage.getItem("role") !== roles.advertiser && <td>{item.total_click > 0 && item.total_imp > 0 ? ((item.total_click / item.total_imp)*100).toFixed(2) : 0}</td>}
                    {localStorage.getItem("role") !== roles.advertiser && <td>{camp.campaign_type === "CPC" && item.total_click > 0 && item.total_imp > 0 ? (((camp.cpc_price * item.total_click) / (item.total_imp)) * 1000).toFixed(2) : camp.campaign_type === "CPM" && item.total_imp > 0 ? ((((camp.cpm * item.total_imp) / 1000) / item.total_imp) * 1000).toFixed(2) : camp.campaign_type === "CPD" ? camp.cpd : "0"}</td>}
                    <td>{localStorage.getItem("role") !== roles.advertiser ? (parseInt(camp.total_budget) === 0 ? camp.cpd : (item.total_click > 0 || item.total_imp > 0) ? (camp.campaign_type === "CPC" ? (parseFloat(camp.cpc_price) * item.total_click).toFixed(2) : camp.campaign_type === "CPM" ? ((parseFloat(camp.cpm) * item.total_imp) / 1000).toFixed(2) : 0) : "0") : (parseInt(camp.total_budget) === 0 ? camp.cpd : (item.adv_total_click > 0 || item.adv_total_imp > 0) ? (camp.campaign_type === "CPC" ? (parseFloat(camp.cpc_price) * item.adv_total_click).toFixed(2) : camp.campaign_type === "CPM" ? ((parseFloat(camp.cpm) * item.adv_total_imp) / 1000).toFixed(2) : 0) : "0")}</td>
                    {localStorage.getItem("role") !== roles.advertiser && <td>{(parseInt(camp.total_budget) === 0 ? camp.cpd : (item.adv_total_click > 0 || item.adv_total_imp > 0) ? (camp.campaign_type === "CPC" ? (parseFloat(camp.cpc_price) * item.adv_total_click).toFixed(2) : camp.campaign_type === "CPM" ? ((parseFloat(camp.cpm) * item.adv_total_imp) / 1000).toFixed(2) : 0) : "0")}</td>}                  
                  </tr>

                )
              })}
            </tbody>
          ) : !data?.length && !loader ? (
            <NoDataFound colspan="15" />
          ) : (
            <TableLoader colspan="15" />
          )}
        </table>
      </div>
      <div>
        {totalPages > 1 && <Paginator
          pageCount={totalPages}
          handlePageClick={handlePageClick}
          forcePage={currentPage}
        />
        }
      </div>
    </div>
  )
}

export default LangwiseReport
